export const welcomePageTimeoutOptions = [
    {value: 1, label: '1 час'},
    {value: 24, label: '1 день'},
    {value: 24*7, label: '7 дней'},
    {value: 24*30, label: '30 дней'},
];

export const positionOptions = [
    {value: 'hide', label: 'Скрыть'},
    {value: 'bottom', label: 'Внизу'},
    {value: 'right', label: 'Справа'},
];

export const playerSizeOptions = [
    {value: '', label: '800/1080 px'},
    {value: 'wide', label: 'На всю ширину'}
];

export const fontSizeOptions = [];
for(let i = 8; i <= 32; i++) {
    fontSizeOptions.push({value: i, label: i + 'px'});
}
